import { Command } from "selenium-webdriver";
import { CommandAction } from "src/app/abstract/command/command-action.service";
import { CommandArrayService } from "src/app/services/command/command-array.service";
import { CommandCheckboxService } from "src/app/services/command/command-checkbox.service";
import { CommandColumnService } from "src/app/services/command/command-column.service";
import { CommandFieldService } from "src/app/services/command/command-field.service";
import { CommandInputService } from "src/app/services/command/command-input.service";
import { CommandQuestionService } from "src/app/services/command/command-question.service";
import { CommandRadioService } from "src/app/services/command/command-radio.service";
import { CommandRowService } from "src/app/services/command/command-row.service";
import { CommandSectionService } from "src/app/services/command/command-section.service";
import { CommandTextService } from "src/app/services/command/command-text.service";
import { CommandTimeRangeService } from "src/app/services/command/command-time-range.service";
import { RenderArrayService } from "src/app/services/render/render-array-service";
import { RenderCheckboxService } from "src/app/services/render/render-checkbox.service";
import { RenderColumnService } from "src/app/services/render/render-column.service";
import { RenderFieldService } from "src/app/services/render/render-field.service";
import { RenderFormService } from "src/app/services/render/render-form.service";
import { RenderInputService } from "src/app/services/render/render-input.service";
import { RenderQuestionService } from "src/app/services/render/render-question.service";
import { RenderRadioService } from "src/app/services/render/render-radio.service";
import { RenderRowService } from "src/app/services/render/render-row.service";
import { RenderSectionService } from "src/app/services/render/render-section.service";
import { RenderTextService } from "src/app/services/render/render-text.service";
import { RenderTimeRangeService } from "src/app/services/render/render-time-range.service";
import { RenderService } from "src/app/services/render/render.service";
import { CloneColumnService } from "src/app/services/clone/clone-column.service";
import { CloneFormService } from "src/app/services/clone/clone-form.service";
import { CloneQuestionService } from "src/app/services/clone/clone-question.service";
import { CloneRowService } from "src/app/services/clone/clone-row.service";
import { CloneSectionService } from "src/app/services/clone/clone-section.service";
import { CloneArrayService } from "src/app/services/clone/clone-array.service";
import { CloneTextService } from "src/app/services/clone/clone-text.service";
import { ClonePrimitiveService } from "src/app/services/clone/clone-primitive.service";
import { MetadataCheckboxComponent } from "src/app/components/widgets/metadata-checkbox/metadata-checkbox.component";
import { WidgetsCheckboxComponent } from "src/app/components/widgets/widgets-checkbox/widgets-checkbox.component";
import { MetadataInputComponent } from "src/app/components/widgets/metadata-input/metadata-input.component";
import { MetadataFieldComponent } from "src/app/components/widgets/metadata-field/metadata-field.component";
import { WidgetsTextModel } from "src/app/models/widgets/widgets-text.model";
import { WidgetsFieldModel } from "src/app/models/widgets/widgets-field.model";
import { WidgetsRadioModel } from "src/app/models/widgets/widgets-radio.model";
import { MetadataRadioComponent } from "src/app/components/widgets/metadata-radio/metadata-radio.component";
import { CloneValidationService } from "src/app/services/clone/clone-validation.service";
import { MetadataBuiltinFieldComponent } from "src/app/components/widgets/metadata-builtin-field/metadata-builtin-field.component";
import { WidgetsTimeRangeModel } from "../../models/widgets/widgets-time-range.model";
import { MetadataTimeRangeComponent } from "../../components/widgets/metadata-timeRange/metadata-timerange.component";
import { WidgetsRelatedinputModel } from "src/app/models/widgets/widgets-related-input.model";
import { CommandRealtedInputService } from "src/app/services/command/command-related-input.service";
import { RenderInputRelatedService } from "src/app/services/render/render-input-related.service";
import { MetadataRelatedInputComponent } from "src/app/components/widgets/metadata-related-input/metadata-related-input.component";

/* eslint-disable @typescript-eslint/naming-convention */

/**
 * List of types of nodes that can exist in the layout tree
 */
 export enum WidgetsClassEnum {
  CONTAINER,
  PRIMITIVE,
  VALIDATION
}

/**
 * List of nodes that can exist in the layout tree
 */
export enum WidgetsTypeEnum {
  FORM,         // F    0
  SECTION,      // S    1
  QUESTION,     // Q    2
  ROW,          // R    3
  COLUMN,       // C    4
  ARRAY,        // A    5
  FIELD,        // I    6
  TEXT,         // T    7
  VALDN_COMP,   // VC   8
  VALDN_DATE,   // VD   9
  VALDN_IP,     // VI   10
  VALDN_YEAR,   // VY   11
  VALDN_SUM,    // VS   12
  RADIO,        // O    13
  CHECKBOX,     // CB   14
  INPUT,        // IN   15
  NONE,         // NN   16
  TIME_RANGE,   // TR   17
  VALDN_TIMERANGE, //VT   18
  SELECT,           // 19 - HTML Select box and multiselect
  TEXTAREA,         // 20 - HTML Text area
  SLIDER,           // 21 - SLIDER
  NUMBER_TABLE,     // 22 - Table of numbers with sum/total
  ORDINAL_IN_SET,   // 23 - Two numbers (Page 1 of 3, Floor 3 of 8)
  RESERVED1,        // 24 - Reserved for future use
  RESERVED2,        // 25 - Reserved for future use
  RESERVED3,        // 26 - Reserved for future use
  RESERVED4,        // 27 - Reserved for future use
  RESERVED5,        // 28 - Reserved for future use
  RESERVED6,        // 29 - Reserved for future use
  RESERVED7,        // 30 - Reserved for future use
  RESERVED8,        // 31 - Reserved for future use
  RESERVED9,        // 32 - Reserved for future use
  RESERVED10,       // 33 - Reserved for future use
  RESERVED11,       // 34 - Reserved for future use
  RESERVED12        // 35 - Reserved for future use
}

/**
 * Interface of configurable items for a node
 */
export interface WidgetsConfig {
  ord: number;
  type: WidgetsClassEnum;
  label: string;
  create: any;
  render: any;
  clone: any;
  metadata: any;
  model: any;
}

/**
 * Map of Services to manipulate (create, render, clone) each specific primitive type
 * NOTE: Typically used while dragging and dropping or previewing (rendering) a primitive into the canvas
 */
export const WidgetsConfigController = new Map<WidgetsTypeEnum, WidgetsConfig>([
  // Containers
  [
    WidgetsTypeEnum.NONE,
    {
      ord: 16,
      label: 'none',
      type: WidgetsClassEnum.CONTAINER,
      create: undefined,
      render: undefined,
      clone: undefined,
      metadata: undefined,
      model: undefined,
    },
  ],
  [
    WidgetsTypeEnum.FORM,
    {
      ord: 0,
      label: 'form',
      type: WidgetsClassEnum.CONTAINER,
      create: undefined,
      render: RenderFormService,
      clone: CloneFormService,
      metadata: undefined,
      model: undefined,
    },
  ],
  [
    WidgetsTypeEnum.SECTION,
    {
      ord: 1,
      label: 'section',
      type: WidgetsClassEnum.CONTAINER,
      create: CommandSectionService,
      render: RenderSectionService,
      clone: CloneSectionService,
      metadata: undefined,
      model: undefined,
    },
  ],
  [
    WidgetsTypeEnum.QUESTION,
    {
      ord: 2,
      label: 'question',
      type: WidgetsClassEnum.CONTAINER,
      create: CommandQuestionService,
      render: RenderQuestionService,
      clone: CloneQuestionService,
      metadata: undefined,
      model: undefined,
    },
  ],
  [
    WidgetsTypeEnum.ROW,
    {
      ord: 3,
      label: 'row',
      type: WidgetsClassEnum.CONTAINER,
      create: CommandRowService,
      render: RenderRowService,
      clone: CloneRowService,
      metadata: MetadataFieldComponent,
      model: undefined,
    },
  ],
  [
    WidgetsTypeEnum.COLUMN,
    {
      ord: 4,
      label: 'column',
      type: WidgetsClassEnum.CONTAINER,
      create: CommandColumnService,
      render: RenderColumnService,
      clone: CloneColumnService,
      metadata: MetadataFieldComponent,
      model: undefined,
    },
  ],
  [
    WidgetsTypeEnum.ARRAY,
    {
      ord: 5,
      label: 'array',
      type: WidgetsClassEnum.CONTAINER,
      create: CommandArrayService,
      render: RenderArrayService,
      clone: CloneArrayService,
      metadata: MetadataFieldComponent,
      model: undefined,
    },
  ],

  // Primitives
  [
    WidgetsTypeEnum.TEXT,
    {
      ord: 7,
      label: 'text',
      type: WidgetsClassEnum.PRIMITIVE,
      create: CommandTextService,
      render: RenderTextService,
      clone: CloneTextService,
      metadata: MetadataFieldComponent,
      model: WidgetsTextModel,
    },
  ],
  [
    WidgetsTypeEnum.FIELD,
    {
      ord: 6,
      label: 'field',
      type: WidgetsClassEnum.PRIMITIVE,
      create: CommandFieldService,
      render: RenderFieldService,
      clone: ClonePrimitiveService,
      metadata: MetadataBuiltinFieldComponent,
      model: WidgetsFieldModel,
    },
  ],
  [
    WidgetsTypeEnum.RADIO,
    {
      ord: 13,
      label: 'radio',
      type: WidgetsClassEnum.PRIMITIVE,
      create: CommandRadioService,
      render: RenderRadioService,
      clone: ClonePrimitiveService,
      metadata: MetadataRadioComponent,
      model: WidgetsRadioModel,
    },
  ],
  [
    WidgetsTypeEnum.CHECKBOX,
    {
      ord: 14,
      label: 'checkbox',
      type: WidgetsClassEnum.PRIMITIVE,
      create: CommandCheckboxService,
      render: RenderCheckboxService,
      clone: ClonePrimitiveService,
      metadata: MetadataCheckboxComponent,
      model: WidgetsCheckboxComponent,
    },
  ],
  [
    WidgetsTypeEnum.INPUT,
    {
      ord: 15,
      label: 'input',
      type: WidgetsClassEnum.PRIMITIVE,
      create: CommandInputService,
      render: RenderInputService,
      clone: ClonePrimitiveService,
      metadata: MetadataInputComponent,
      model: MetadataInputComponent,
    },
  ],
  [
    WidgetsTypeEnum.TIME_RANGE,
    {
      ord: 17,
      label: 'timeRange',
      type: WidgetsClassEnum.PRIMITIVE,
      create: CommandTimeRangeService,
      render: RenderTimeRangeService,
      clone: ClonePrimitiveService,
      metadata: MetadataTimeRangeComponent,
      model: WidgetsTimeRangeModel,
    },
  ],
  [
    WidgetsTypeEnum.ORDINAL_IN_SET,
    {
      ord: 23,
      label: 'related-input',
      type: WidgetsClassEnum.PRIMITIVE,
      create:  CommandRealtedInputService,
      render: RenderInputRelatedService,
      clone: ClonePrimitiveService,
      metadata: MetadataRelatedInputComponent,
      model: WidgetsRelatedinputModel,
    },
  ],

  // Validations
  [
    WidgetsTypeEnum.VALDN_COMP,
    {
      ord: 8,
      label: 'comp',
      type: WidgetsClassEnum.VALIDATION,
      create: undefined,
      render: undefined,
      clone: CloneValidationService,
      metadata: undefined,
      model: undefined,
    },
  ],
  [
    WidgetsTypeEnum.VALDN_DATE,
    {
      ord: 9,
      label: 'date',
      type: WidgetsClassEnum.VALIDATION,
      create: undefined,
      render: undefined,
      clone: CloneValidationService,
      metadata: undefined,
      model: undefined,
    },
  ],
  [
    WidgetsTypeEnum.VALDN_IP,
    {
      ord: 10,
      label: 'ip',
      type: WidgetsClassEnum.VALIDATION,
      create: undefined,
      render: undefined,
      clone: CloneValidationService,
      metadata: undefined,
      model: undefined,
    },
  ],
  [
    WidgetsTypeEnum.VALDN_YEAR,
    {
      ord: 11,
      label: 'year',
      type: WidgetsClassEnum.VALIDATION,
      create: undefined,
      render: undefined,
      clone: CloneValidationService,
      metadata: undefined,
      model: undefined,
    },
  ],
  [
    WidgetsTypeEnum.VALDN_SUM,
    {
      ord: 12,
      label: 'sum',
      type: WidgetsClassEnum.VALIDATION,
      create: undefined,
      render: undefined,
      clone: CloneValidationService,
      metadata: undefined,
      model: undefined,
    },
  ],
  [
    WidgetsTypeEnum.VALDN_TIMERANGE,
    {
      ord: 18,
      label: 'timeRangeVal',
      type: WidgetsClassEnum.VALIDATION,
      create: undefined,
      render: undefined,
      clone: CloneValidationService,
      metadata: undefined,
      model: undefined,
    },
  ],
]);

/* eslint-enable @typescript-eslint/naming-convention */
